import React, { useState, useEffect } from "react";
import { Modal, Backdrop, Fade, Grid, Typography, Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { GetTitlesCall } from "../../redux/api/title.api";
import MDBox from "components/MDBox";
import { isEmpty } from "lodash";

const SlideSelectorModal = ({ open, onClose, onSelect, type }) => {
  const lang = useSelector((state) => state.general?.lang);
  const [titles, setTitles] = useState([]);

  const fetchTitles = async () => {
    const res = await GetTitlesCall(lang, type);
    console.log("pippo res", res);

    setTitles(res || []);
  };

  useEffect(() => {
    if (open) fetchTitles();
  }, [open, lang, type]);

  const renderItem = (item, index) => {
    const filteredTitle = item?.titleLocalizations?.filter((e) => e.field == "title");

    const title = filteredTitle?.[0]?.value || "Click to edit the title";
    const url = require("../../assets/images/no-image.jpg");
    return (
      <MDBox
        mb={3}
        p={2}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        border="1px solid #ccc"
        borderRadius="8px"
      >
        {title}
        {item?.subtitles?.length > 0 && (
          <Grid container spacing={2} mt={2}>
            {item.subtitles.map((subtitle, idx) => {
              const label = isEmpty(subtitle?.slides) ? "Add Material" : "Edit Material";

              const filteredTitle = subtitle?.titleLocalizations?.filter((e) => e.field == "title");
              const filteredBody = subtitle?.titleLocalizations?.filter((e) => e.field == "body");

              const title = filteredTitle?.[0]?.value || "Click to edit the sub title";
              const body = filteredBody?.[0]?.value || "Click to edit the sub body";
              return (
                <Grid item xs={12} sm={6} md={4} key={subtitle.id}>
                  <MDBox
                    p={2}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    borderRadius="8px"
                    style={{ backgroundColor: "white" }}
                  >
                    <img
                      src={
                        isEmpty(subtitle?.slides?.[0]?.Files?.[0]?.url)
                          ? url
                          : subtitle?.slides?.[0]?.Files?.[0]?.url + "/3/3/3.png"
                      }
                      onClick={() => onSelect(title, subtitle?.slides?.[0]?.Files?.[0]?.url)}
                      alt={title}
                      style={{
                        width: !isEmpty(subtitle?.slides?.[0]?.Files?.[0]?.url) ? "100%" : "50%",
                        height: "auto",
                        borderRadius: "8px",
                        marginBottom: "10px",
                      }}
                    />

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {title}
                    </div>
                  </MDBox>
                </Grid>
              );
            })}
          </Grid>
        )}
      </MDBox>
    );
  };

  const url = require("../../assets/images/no-image.jpg");

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxHeight: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            Select a Slide
          </Typography>
          <Grid container spacing={3}>
            {!isEmpty(titles) &&
              titles.map((item, index) => (
                <Grid item xs={12} key={item.id}>
                  {renderItem(item, index)}
                </Grid>
              ))}
          </Grid>
          <Box mt={2} textAlign="right">
            <Button variant="outlined" onClick={onClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SlideSelectorModal;
